<template>
  <b-container>
    <h1 class="text-center">HVAC Duct Cleaning</h1>
    <hr>
    <p>The specialists with Commonwealth Moisture &amp; Mold Specialists employ the latest, state-of-the-art duct cleaning system. We also provide a before-and-after cleaning video so you can see the difference. Cleaning your HVAC ducts can:</p>
    <b-table :items="items"/>
    <br>
    <br>
    <br>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {one: 'Provide you with Better Indoor Air Quality', two: 'Reduce the Presence of House Molds & Allergens'},
        {one: 'Git rid of House Dust', two: 'Result in More Airflow & Better Delivery of Warm Air'}
      ]
    }
  }
}
</script>

<style>
thead {
  display: none;
}
</style>
